import { clientId, queryClient } from "@/lib/api";

export function connectSSE(): () => void {
  const source = new EventSource("/api/events");

  source.onmessage = (msg) => {
    const event = JSON.parse(msg.data);

    if (event.type === "playback") {
      queryClient.setQueryData(["playback"], event.state);
      return;
    }

    if (event.type === "download") {
      queryClient.setQueryData(["download"], event);
      return;
    }

    if (event.clientId === clientId) return;

    for (const queryKey of event.queryKeys) {
      queryClient.invalidateQueries({ queryKey });
    }
  };

  return () => source.close();
}
